import { integrationApiInstance } from "../../apis/integrationApi";
import { DirectorySource, toDirectoryUsers } from "./customerApprovers";

/** Reads approver candidates from the customer's connected Microsoft 365 or Google Workspace tenant. */
export const tenantDirectorySource: DirectorySource = {
  hasConnectedDirectory: async (customerId) => {
    const status = (await integrationApiInstance.getCustomerProductivityAppsStatus(customerId)) as { has_productivity_apps?: unknown };
    return status?.has_productivity_apps === true;
  },
  searchUsers: async (customerId, query) => toDirectoryUsers(await integrationApiInstance.searchCustomerDirectoryUsers(customerId, query)),
};
